var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-ordering-contextual-page-hero',{attrs:{"order-type":_vm.orderType,"order-imagery":""}},[(_vm.twoColumnLayout)?_c('h3',{ref:"title",staticClass:"page-hero__title"},[_vm._v(_vm._s(_vm.title))]):_c('h2',{ref:"title",staticClass:"page-hero__title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }